import { gql } from "@apollo/client";

export const CREATE_EVENT = gql`
    mutation CreateEvent($events: [EventRecordInput!]!, $companyId: Int) {
        createEvent(events: $events, companyId: $companyId) {
            success
        }
    }
`;
